'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preformat = (0, _alias2.default)('pre', 'Preformat'); /**
                                                           * Alias for the pre tag. The Preformat element allows the display of monospaced font
                                                           * and preserves both spaces and line breaks.
                                                           *
                                                           * @module Preformat
                                                           * @func
                                                           * @since 1.0.0
                                                           * @param {Object} props
                                                           */

exports.default = Preformat;